/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link, Typography, Typography2, breakpoints } from '@coursera/cds-core';

import useIsMobile from 'bundles/common/hooks/useIsMobile';
import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';
import PartnerSquareLogo from 'bundles/unified-description-page-common/components/shared/PartnerSquareLogo';
import Modal from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import type { ModalProps } from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import type { PartnerFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';
import { getPartnerPageUrl } from 'bundles/unified-description-page-common/utils';

import _t from 'i18n!nls/xdp';

const styles = {
  container: () => css`
    display: flex;
    gap: var(--cds-spacing-400);
    align-items: start;
    ${breakpoints.down('xs')} {
      flex-direction: column;
    }
  `,
  partnerInfo: () => css`
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: var(--cds-spacing-400);
  `,
  partnerName: () => css`
    text-decoration-color: var(--cds-color-neutral-primary);
  `,
};

type Props = ModalProps & {
  partner: PartnerFragment;
};

const Partner = ({ partner, ...rest }: Props) => {
  const isMobile = useIsMobile();

  return (
    <Modal {...rest} header={_t('Offered by')} width="large">
      <div css={styles.container}>
        {partner.squareLogo && <PartnerSquareLogo src={partner.squareLogo} width={isMobile ? 60 : 112} />}
        <div css={styles.partnerInfo}>
          <Link
            component={TrackedLink2}
            href={getPartnerPageUrl(partner.shortName)}
            trackingName="partner"
            css={styles.partnerName}
          >
            <Typography component="span" variant="h1semibold">
              {partner.name}
            </Typography>
          </Link>
          {partner.description && (
            <Typography2 component="p" variant="bodyPrimary">
              {partner.description}
            </Typography2>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default Partner;
